declare namespace $ {

	type $mol_string__value_shm_hitalama_map_widget_float_customizer_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['title'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_customizer_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_customizer_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['visible_in_menu'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_button_major__title_shm_hitalama_map_widget_float_customizer_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_map_widget_float_customizer_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['create_instance'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_customizer_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__hint_shm_hitalama_map_widget_float_customizer_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_hitalama_map_widget_float_customizer_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['fqn'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_customizer_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_hitalama_map_widget_float_customizer_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['rename_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_customizer_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['rename'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_customizer_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_button_copy__title_shm_hitalama_map_widget_float_customizer_13 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_copy['title'] >
	>
	type $shm_button_copy__text_shm_hitalama_map_widget_float_customizer_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['definition_link'] >
		,
		ReturnType< $shm_button_copy['text'] >
	>
	type $mol_list__sub_shm_hitalama_map_widget_float_customizer_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	type $shm_textarea_code__title_shm_hitalama_map_widget_float_customizer_16 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_textarea_code['title'] >
	>
	type $shm_textarea_code__sidebar_showed_shm_hitalama_map_widget_float_customizer_17 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_textarea_code['sidebar_showed'] >
	>
	type $shm_textarea_code__value_shm_hitalama_map_widget_float_customizer_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['code_view_tree'] >
		,
		ReturnType< $shm_textarea_code['value'] >
	>
	type $shm_textarea_code__title_shm_hitalama_map_widget_float_customizer_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['style_title'] >
		,
		ReturnType< $shm_textarea_code['title'] >
	>
	type $shm_textarea_code__sidebar_showed_shm_hitalama_map_widget_float_customizer_20 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_textarea_code['sidebar_showed'] >
	>
	type $shm_textarea_code__value_shm_hitalama_map_widget_float_customizer_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['code_css'] >
		,
		ReturnType< $shm_textarea_code['value'] >
	>
	type $shm_textarea_code__title_shm_hitalama_map_widget_float_customizer_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['logic_title'] >
		,
		ReturnType< $shm_textarea_code['title'] >
	>
	type $shm_textarea_code__sidebar_showed_shm_hitalama_map_widget_float_customizer_23 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_textarea_code['sidebar_showed'] >
	>
	type $shm_textarea_code__value_shm_hitalama_map_widget_float_customizer_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['code_js'] >
		,
		ReturnType< $shm_textarea_code['value'] >
	>
	type $shm_textarea_code__title_shm_hitalama_map_widget_float_customizer_25 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_textarea_code['title'] >
	>
	type $shm_textarea_code__hint_shm_hitalama_map_widget_float_customizer_26 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_textarea_code['hint'] >
	>
	type $shm_textarea_code__value_shm_hitalama_map_widget_float_customizer_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['dependencies_text'] >
		,
		ReturnType< $shm_textarea_code['value'] >
	>
	type $mol_deck__current_shm_hitalama_map_widget_float_customizer_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['soure_type_current'] >
		,
		ReturnType< $mol_deck['current'] >
	>
	type $mol_deck__items_shm_hitalama_map_widget_float_customizer_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_deck['items'] >
	>
	export class $shm_hitalama_map_widget_float_customizer extends $shm_hitalama_map_widget_float {
		title( next?: string ): string
		Name( ): $mol_string
		visible_in_menu( next?: boolean ): boolean
		Visible( ): $mol_check_box
		create_instance( next?: any ): any
		Create( ): $mol_button_major
		Head( ): $mol_view
		fqn( next?: string ): string
		Fqn( ): $mol_string
		rename_enabled( ): boolean
		rename( next?: any ): any
		Rename( ): $mol_button_minor
		Fqn_row( ): $mol_view
		definition_link( ): string
		Definition_link( ): $shm_button_copy
		Controls( ): $mol_list
		Deck_switch( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_customizer['Deck'] >['Switch'] >
		Deck_content( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_customizer['Deck'] >['Content'] >
		soure_type_current( next?: string ): string
		code_view_tree( next?: string ): string
		View_tree( ): $shm_textarea_code
		style_title( ): string
		code_css( next?: string ): string
		Css( ): $shm_textarea_code
		logic_title( ): string
		code_js( next?: string ): string
		Js( ): $shm_textarea_code
		dependencies_text( next?: string ): string
		Dependencies( ): $shm_textarea_code
		controls( ): readonly(any)[]
		Deck( ): $mol_deck
		attr( ): ({ 
			'mol_theme': string,
		})  & ReturnType< $shm_hitalama_map_widget_float['attr'] >
	}
	
}

//# sourceMappingURL=customizer.view.tree.d.ts.map